import About from "../components/sections/About";
import SideList from "../components/sections/SideList";
import Title from "../components/sections/Title";
import UsefulFor from "../components/sections/UsefulFor";
import WideContainer from "../components/WideContainer";
import CenteredRow from "../components/CenteredRow";
import { about, after, before, during, technique, usefulFor } from "../content/Bowen";

const color = "bowen";

function Bowen() {
  return (
    <main className="flex-grow-1">
      <Title title="Bowen" color={color} />
      <About title="Bowen-kezelés" paragraphs={about} color={color} />
      <SideList
        id="before"
        title="Kezelés előtt"
        listItems={before}
        color={color}
      />
      <SideList
        id="during"
        title="Kezelés alatt"
        secondaryText="(30-40 perc)"
        listItems={during}
        alignRight={true}
        color={color}
      />
      <SideList
        id="after"
        title="Kezelés után"
        listItems={after}
        color={color}
      />
      <UsefulFor listItems={usefulFor} color={color} />

      <WideContainer id="first-time">
        <h1 className="display-6 fw-bold text-body-emphasis quint bowen">
          Tudnivalók az első kezelésről
        </h1>
        <div className="col-lg-10 mx-auto">
          <p className="mb-0">
            Általános és speciális kérdésekkel igyekszem teljes képet kapni a
            testről. Néhány egyszerű <b>állapotfelmérés</b> után egy bowen{" "}
            <b>alapkezelés</b> következik. Ekkor ismerkedem én is a fizikális
            területekkel és az azonnali vagy több nappal későbbi reakciókból
            tudjuk meg, hogy hol vannak a blokkolt területek.
          </p>
        </div>
      </WideContainer>
      <WideContainer id="bowen-technic">
        <h1 className="display-5 fw-bold text-body-emphasis quint bowen">
          Bowen technika
        </h1>
        <CenteredRow>
          <p className="mb-2">
            {technique}
          </p>
          <hr className="hr bowen" />
          <p className="my-0">Hivatalos weboldal:</p>
          <a href="https://www.bowen.hu">
            <img
              className="rounded-3 px-2 bg-bowen box-shadow"
              src={process.env.PUBLIC_URL + "/images/bowtech_logo.png"}
              alt="bowtech logo"
              width={150}
            />
          </a>
        </CenteredRow>
      </WideContainer>
    </main>
  );
}

export default Bowen;
